import { BarChart, ChartPanel, ScatterChart } from "@/components/analytics";

interface ResidualData {
  scatter: Array<{ predicted: number; residual: number }>;
  histogram: Array<{ bin: string; count: number }>;
}

interface ResidualAnalysisVizProps {
  data: ResidualData;
}

export function ResidualAnalysisViz({ data }: ResidualAnalysisVizProps) {
  return (
    <div className="grid grid-cols-2 gap-4">
      <ChartPanel title="Residuals vs Predicted">
        <ScatterChart
          data={data.scatter}
          xKey="predicted"
          yKey="residual"
          height={400}
          referenceY={0}
        />
      </ChartPanel>

      <ChartPanel title="Residual Distribution">
        <BarChart data={data.histogram} dataKey="count" nameKey="bin" height={400} />
      </ChartPanel>
    </div>
  );
}
